import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  contactsList: {
    maxHeight: 500,
    overflowY: 'auto',
    padding: '8px'
  },
  comments: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  button: {
    alignSelf: 'center'
  },
  alert: {
    padding: '20px 24px'
  }
}))
